import type {
  GetKnowledgeArticleListRequestV2,
  GetListResponseOfKnowledgeArticleSimpleResponse,
  KnowledgeArticleRequest,
  KnowledgeArticleResponse,
} from 'src/api/ProactApiClient';
import {knowledgeBaseApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const knowledgeBaseApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getKnowledgeArticleListV2: builder.query<
      GetListResponseOfKnowledgeArticleSimpleResponse,
      GetKnowledgeArticleListRequestV2
    >({
      queryFn: clientQuery(request => knowledgeBaseApiClient.listV2(request)),
      providesTags: ['KnowledgeArticles'],
    }),
    getKnowledgeArticle: builder.query<KnowledgeArticleResponse, number>({
      queryFn: clientQuery(id => knowledgeBaseApiClient.get(id)),
      providesTags: ['KnowledgeArticles'],
    }),
    createKnowledgeArticle: builder.mutation<
      KnowledgeArticleResponse,
      KnowledgeArticleRequest
    >({
      queryFn: clientQuery(request => knowledgeBaseApiClient.create(request)),
      invalidatesTags: ['KnowledgeArticles'],
    }),
    updateKnowledgeArticle: builder.mutation<
      KnowledgeArticleResponse,
      KnowledgeArticleRequest
    >({
      queryFn: clientQuery(request => knowledgeBaseApiClient.update(request)),
      invalidatesTags: ['KnowledgeArticles'],
    }),
    deleteKnowledgeArticle: builder.mutation<void, number>({
      queryFn: voidClientQuery(id => knowledgeBaseApiClient.delete(id)),
      invalidatesTags: ['KnowledgeArticles'],
    }),
  }),
});

export const {
  useGetKnowledgeArticleListV2Query,
  useGetKnowledgeArticleQuery,
  useCreateKnowledgeArticleMutation,
  useUpdateKnowledgeArticleMutation,
  useDeleteKnowledgeArticleMutation,
} = knowledgeBaseApi;
